import { useQuery } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  ApplicationGetApplicationQuery,
  ApplicationGetApplicationQueryVariables,
} from '@gql/graphql';

export const APPLICATION_GET_APPLICATION = graphql(`
  query ApplicationGetApplication($where: DogBreederApplicationWhereUniqueInput!) {
    findUniqueApplication(where: $where) {
      id
      status
      animal {
        id
        birthday
        gender
        name
        dogInfos {
          id
          dogBreedId
        }
      }
    }
  }
`);

export const useGetApplication = (applicationId?: number) => {
  const { loading, data } = useQuery<
    ApplicationGetApplicationQuery,
    ApplicationGetApplicationQueryVariables
  >(APPLICATION_GET_APPLICATION, {
    variables: {
      where: { id: applicationId ?? 0 },
    },
    ssr: false,
    fetchPolicy: 'no-cache',
  });

  return {
    applicationLoading: loading,
    application: data?.findUniqueApplication,
  };
};
